(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-amp-product]').forEach(section => {
    if (section.dataset.refReady) return;
    section.dataset.refReady = 'true';
    const thumbs = [...section.querySelectorAll('[data-amp-thumbnail]')];
    const dots = [...section.querySelectorAll('[data-am-gallery-dot]')];
    const sync = () => {
      const index = Math.max(0, thumbs.findIndex(el => el.classList.contains('is-active')));
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-pressed', String(i === index)); });
    };
    const move = offset => {
      if (!thumbs.length) return;
      const current = Math.max(0, thumbs.findIndex(el => el.classList.contains('is-active')));
      thumbs[(current + offset + thumbs.length) % thumbs.length].click(); sync();
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { thumbs[i]?.click(); sync(); }));
    thumbs.forEach(thumb => thumb.addEventListener('click', sync));
    section.querySelector('[data-am-gallery-prev]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-am-gallery-next]')?.addEventListener('click', () => move(1));
    const gallery = section.querySelector('[data-amp-gallery-main]');
    let start = null;
    gallery?.addEventListener('touchstart', e => { start = [e.changedTouches[0].clientX, e.changedTouches[0].clientY]; }, { passive: true });
    gallery?.addEventListener('touchend', e => {
      if (!start) return;
      const dx = e.changedTouches[0].clientX - start[0], dy = e.changedTouches[0].clientY - start[1];
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
      start = null;
    }, { passive: true });
    section.querySelector('[data-am-choose-package]')?.addEventListener('click', () => {
      const target = section.querySelector('[data-amb-builder]') || section.querySelector('.amp-buy');
      target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      const control = target?.querySelector('input:checked') || target?.querySelector('button');
      control?.focus({ preventScroll: true });
    });
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
